import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import SchoolYearFields from './SchoolYearFields'

export const SchoolYearEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <SchoolYearFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default SchoolYearEdit
